import type {PackageTemplate, Service} from ".";
/**
 * Services are categorised based on their goals.
 * Within the same basistype category of the sevrices, there might exist multiple goal options.
 *
 * Each goal is attributed by one (and only one) basistype.
 * A basistype covers many goals.
 */

export class Goal {
  id: number;
  name: string;
  private _serviceTypes: Service[] = [];
  private _basisTypeId: number | undefined;

  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
  }

  public addServiceTypes = (serviceTypes: Service[]): Goal => {
    serviceTypes.forEach(this.addServiceType);
    return this;
  };

  public get isDisabled(): boolean {
    const res = !this.services.some((service) => {
      const serviceHasTime = service.isDisabled === false;
      return serviceHasTime;
    });
    return res;
  }

  private addServiceType = (serviceType: Service): void => {
    if (!this._serviceTypes.includes(serviceType)) {
      serviceType.addGoal(this);
      this._serviceTypes = [...this._serviceTypes, serviceType];
    }
  };

  public addBasisTypeId = (basisTypeId: number): void => {
    this._basisTypeId = basisTypeId;
  };

  get basisTypeId(): number {
    if (this._basisTypeId === undefined) throw new Error("BasisTypeId is undefined");
    return this._basisTypeId;
  }

  get cheapestService(): Service {
    const cheapestServices = this._serviceTypes.map((s) => {
      return {service: s, cheapest: s.cheapestPartner.getPrice(s)};
    });
    const cheapestService = cheapestServices.reduce((prev, current) => (prev.cheapest < current.cheapest ? prev : current));
    return cheapestService.service;
  }

  public get packages(): PackageTemplate[] {
    const packages = this.services.reduce<PackageTemplate[]>((prev, current) => [...prev, ...current.packages], []);
    return packages;
  }

  public get services(): Service[] {
    return this._serviceTypes;
  }

  /**
   * @param goal - to compare current goal against
   * @returns true if ids are matching
   */
  public equals(goal: Goal): boolean {
    return this.id === goal.id;
  }
}
